import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../Component/axiosInstance";
import axiosInstance from "../../../Component/axiosInstance";
import Cookies from 'js-cookie';

// Async thunk for adding a company
const GetTransportDetail = createAsyncThunk('transportDetail', async (projectid, { rejectWithValue }) => {
    try {
        // console.log("yo hai transhport detail ",projectid);
        // return ;
        const response = await axiosInstance.get(`/project/getTransportProjection`,   {
            headers: {
                'x-auth-token': localStorage.getItem('token'),
                'x-project-id':projectid
            }
        });
        // console.log(response.data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
});

// Slice for managing add company state
const GetTransportDetailSlice = createSlice({
    name: 'GettransportDetail',
    initialState: {
        loading: false,
        error: null,
        data: null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetTransportDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.data = null;
                state.isSuccess = false;
                state.isError = false;
            })
            .addCase(GetTransportDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.isSuccess = true;
                state.isError = false;
            })
            .addCase(GetTransportDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.data = null;
                state.isError = true;
                state.isSuccess = false;
            });
    }
});
export { GetTransportDetail };
export default GetTransportDetailSlice.reducer;